import { render } from "./ArticleGroups.vue?vue&type=template&id=bc0deb54"
import script from "./ArticleGroups.vue?vue&type=script&lang=js"
export * from "./ArticleGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__